import React from "react";

function FounderProfile() {
  return (
    <main>
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Founder Profile</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Founder Profile</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="team_details_section pt_150 pb_150">
        <div className="container">
          <div className="row">
            {/* Author Content */}
            <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
              <div className="author_content">
                <h3 className="author_name">BHARGAV CHAUHANs</h3>
                <span className="author_designation">
                  Founder & Proprietor – Shivom Financial
                </span>
                <p>
                  Financial Services | Fund Management | Capital Markets |
                  Global Investments
                </p>
                <div className="author_comment">
                  <h3>Profile Summary</h3>
                  <p>
                    Mr. Bhargav Chauhan is a veteran financial services
                    professional with over 40 years of diversified experience
                    across cooperative finance, private equity, banking
                    distribution, real estate development, Indian capital
                    markets, portfolio management, and global forex trading.
                    Based in Mumbai, India, he combines deep grassroots
                    financial expertise with extensive international market
                    exposure, making him a trusted partner for investors,
                    institutions, and joint-venture associates.
                  </p>
                  <h3>Professional Background</h3>
                  <p>
                    Mr. Chauhan began his career at the age of 18 with a Credit
                    Society, gaining hands-on experience in lending, credit
                    assessment, and financial operations. By 24, he had served
                    as Director of four Credit Societies and established himself
                    as a Private Equity Provider, arranging and deploying
                    capital for multiple ventures. From 1988 onwards, he
                    expanded into real estate and construction, executing
                    projects across Maharashtra and Gujarat, including Virar,
                    Mira Road, Kandivali, Andheri, Karjat, Dombivli, Kelve Road,
                    and Surat, overseeing funding, execution, and financial
                    management.
                  </p>
                </div>
              </div>
              <div
                className="pricing_block_one aos-init aos-animate text-left mt-5"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="pricing_table " style={{ textAlign: "left" }}>
                  <div className="table_header">
                    <h5>Capital Markets & Global Exposure</h5>
                    <p style={{ textAlign: "left" }} className="mb-0">
                      Mr. Chauhan has extensive experience in Indian capital
                      markets as:
                    </p>
                  </div>
                  <div className="table_content ">
                    <ul className="feature_list text-left">
                      <li className="Coverage-list-2">
                        <span>Sub-Broker</span> - Angel One, IDBI Capitalean
                        financ
                      </li>
                      <li className="Coverage-list-2">
                        <span>Franchisee Partner </span> - Alice Blue, Bigul
                        Bonanza Portfolio Ltd.
                      </li>
                      <li className="Coverage-list-2">
                        <span>Financial Expertise</span>
                        Internationally, he has worked as an Introducing Broker
                        (IB) with leading global institutions, including Gain
                        Capital (USA), REFCO Inc (New York), Easy Forex
                        (Cyprus), GCI Ltd (BVI), Man Financial (UK), TIO
                        Markets, OctaFX, and Exness Technologies Ltd, along with
                        other European financial firms.{" "}
                      </li>
                      <li className="Coverage-list-2">
                        <span>Banking, Lending & Client Reach</span>
                        He has served as a DSA for over 25 banks and NBFCs,
                        successfully facilitating financial solutions for more
                        than 10,000 satisfied clients across lending, project
                        finance, and structured funding.
                      </li>
                      <li className="Coverage-list-2">
                        <span>Core Expertise</span>
                        Financial Services & Capital Structuring | Portfolio &
                        Fund Management | Private Equity & Joint Ventures |
                        Indian & Global Capital Markets | Forex & International
                        Trading | Real Estate & Asset Development | Algorithmic
                        Investments.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Author Information */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="author_information">
                <div className="author_info_title">Current Roles</div>

                <div className="author_info_item">
                  <span>Founder & Proprietor</span>
                  <h6>Shivom Financial</h6>
                </div>

                <div className="author_info_item">
                  <span>Franchisee Partner</span>
                  <h6>Alice Blue, Bigul Bonanza Portfolio Ltd</h6>
                </div>

                <div className="author_info_item">
                  <span>Introducing Broker (IB)</span>
                  <h6>TIO Markets Ltd, Exness Technologies Ltd, Octa FX</h6>
                </div>
              </div>
              <div className="author_information mt-3">
                <div className="author_info_title">
                  Fund Management & Services
                </div>

                <ul className="feature_list text-left">
                  <li className="Coverage-list-3">
                    <span>Portfolio Management Services (PMS)</span>
                  </li>
                  <li className="Coverage-list-3">
                    <span>Account Handling Services</span>
                  </li>
                  <li className="Coverage-list-3">
                    <span>
                      Algorithmic and strategy-based investment solutions
                    </span>
                  </li>
                  <li className="Coverage-list-3">
                    <span>
                      Customized investor and joint-venture financial structures
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default FounderProfile;
